<template>
  <auth-container>
    
    <form class="max-w-xs bg-white p-6 rounded" @submit.prevent="logIn">
      <h2 class="text-2xl mb-6">Login</h2>
      <div v-if="isEmailVerified" class="bg-full-blue text-white py-4 px-2 mb-4 text-sm rounded">
        <p>Your email is verified!</p>
      </div>
      <div v-if="isNumberVerified" class="bg-full-blue text-white py-4 px-2 mb-4 text-sm rounded">
        <p>Your phone number is verified!</p>
      </div>
      <p class="text-sm mb-6">Don't have an account? <router-link
                                                       class="inline-block align-baseline text-sm text-full-blue"
                                                       :to="{name: 'signup', query: {
                                                         redirectFrom: $route.query.redirectFrom}}">Create one!</router-link>
      </p>
      <p class="text-red text-sm italic my-4" v-if="error">
        {{error}}
      </p>
      <p class="text-green text-sm italic my-4" v-if="info">
        {{info}}
      </p>
      <div class="mb-4 flex">

        <div class="pb-4 flex items-center mr-4">
          <input v-model="usertype" type="radio" name="usertype" value="email" />
          <label class="pl-2 text-xs">Email Address</label>
        </div>

        <div class="pb-4 flex items-center">
          <input v-model="usertype" type="radio" name="usertype" value="phone" />
          <label class="pl-2 text-xs">Phone Number</label>
        </div>
      </div>

      <div class="mb-4">
        <div v-if="usertype === 'email'">
          <label class="block text-sm font-bold pb-2" for="username">
            Your Email
          </label>
          <input
            class="appearance-none border-gray-light border rounded w-full py-2 px-3 text-sm text-grey-darker leading-tight focus:outline-none focus:shadow-outline tracking-wide"
            id="username"
            name="username"
            v-model="emailAddress"
            type="text"
            placeholder="Email Address">

        </div>
        <div v-else>
          <label class="block text-sm font-bold pb-2" for="username">
            Your Phone Number
          </label>
          <input
            class="appearance-none border-gray-light border rounded w-full py-2 px-3 text-sm text-grey-darker leading-tight focus:outline-none focus:shadow-outline tracking-wide"
            id="username"
            name="username"
            @input="formatNumber( $event.target.value)"
            :value="phoneNumber"
            type="text"
            placeholder="Phone Number">
        </div>
      </div>
      <div class="mb-6">
        <label class="block text-sm font-bold pb-2" for="password">
          Password
        </label>
        <input
          class="appearance-none border-gray-light border rounded w-full py-2 px-3 text-sm mb-3 focus:outline-none focus:shadow-outline"
          id="password"
          type="password"
          name="password"
          v-model="password"
          placeholder="******************">
        
        <!-- <p></p> -->
      </div>
      <div class="flex items-center justify-end">
        
        <router-link
          class="inline-block align-baseline text-xs text-full-blue"
          to="/forgot-password">Forgot your password?</router-link>

        <button

          class="bg-full-blue ml-4 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline text-sm"
          type="submit"
        >
          Login
        </button>

      </div>

      <div class="mt-6">

        

      </div>
    </form>
    
  </auth-container>
</template>
<script>
 import api from '../api';
 import {mapState, mapGetters, mapActions} from 'vuex';
 import AuthContainer from '@/components/AuthContainer';
 import {AsYouType} from 'libphonenumber-js'

 const infos = {
   reset: 'Your password was successfully reset. Please complete login',
   signup: 'Almost done... We sent you a text with instructions to set a password and complete the signup process.',
   forgot: 'We sent a message with login instructions to your email.'
 }

 export default {
   data() {
     return {
       phoneNumber: '',
       password: '',
       info: '',
       usertype: 'email',
       emailAddress: ''
     }
   },
   components: {AuthContainer},
   computed: Object.assign(
     mapState({
       error: state => state.loginError
     }),
     mapGetters(['isLoggedIn']),
     {
       isEmailVerified () {
         return this.$route.query.emailverified === 'true';
       },
       isNumberVerified () {
         return this.$route.query.numberverified === 'true';
       }
     }
   ),

   created () {
     this.$store.commit('clearErrors');

     if (this.isLoggedIn) {
       return this.$router.replace(this.$route.query.redirectFrom || '/');
     }

     if (this.$route.query.last) {
       this.info = infos[this.$route.query.last];
     }
   },

   methods: Object.assign( mapActions(['login']), {

     async logIn () {
       const username = this.usertype === 'email' ? this.emailAddress : this.phoneNumber

       const res = await this.login({username, password: this.password})
       if (res !== false) {
         this.$router.replace(decodeURIComponent(this.$route.query.redirectFrom || '/'));
       }
     },

     formatNumber (number) {
       const res = new AsYouType('US').input(number);

       this.phoneNumber = res
     }
   }),

   watch: {
     $route (to, from) {
       if (to.query.last) {
         this.info = infos[to.query.last];
       }
     }
   }
 }
</script>
